import * as React from "react";

import style from "./FileDownloader.module.scss";

export interface FileDownloaderStateProps {
  content: React.ReactElement;
  url?: string;
  onConfirm?: () => void;
}

export interface FileDownloaderDispatchProps {
  closeModal: () => void;
}

export interface FileDownloaderProps
  extends FileDownloaderDispatchProps,
    FileDownloaderStateProps {}

export const FileDownloader = (props: FileDownloaderProps) => {
  const { onConfirm } = props;
  return (
    <main className={style.main}>
      <div className={style.header}>
        <div>{props.content}</div>
      </div>
      <div className={style.body}>
        <div className={style.btnArea}>
          <button
            className="btn btn-secondary"
            onClick={() => props.closeModal()}
          >
            {"キャンセル"}
          </button>
          {onConfirm ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                onConfirm();
                props.closeModal();
              }}
            >
              {"OK"}
            </button>
          ) : (
            <a
              href={props.url}
              className="btn btn-primary"
              onClick={() => props.closeModal()}
              rel="noopener noreferrer"
              target="_blank"
            >
              {"OK"}
            </a>
          )}
        </div>
      </div>
    </main>
  );
};
